module.exports = __webpack_public_path__ + "static/media/footer.c04a7a64.png";